// 文件传输公开 API（上传 / 下载 / 列表）

import { getApiBase } from "./fileTransferToken";

function getBase() {
  const base = getApiBase();
  if (!base) throw new Error("API not configured");
  return base;
}

// 获取传输会话信息
export async function fetchSession(token) {
  const base = getBase();
  const url = `${base}/api/file-transfer/${encodeURIComponent(token)}?_=${Date.now()}`;
  const res = await fetch(url, { cache: "no-store" });
  if (res.status === 410) {
    const body = await res.json().catch(() => ({}));
    const err = new Error("SESSION_EXPIRED");
    err.data = body;
    err.status = 410;
    throw err;
  }
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    const err = new Error(body.error?.message || "REQUEST_FAILED");
    err.status = res.status;
    throw err;
  }
  const body = await res.json();
  return body.session;
}

// 获取文件列表（含预签名下载 URL）
export async function fetchFiles(token) {
  const base = getBase();
  const url = `${base}/api/file-transfer/${encodeURIComponent(token)}/files?_=${Date.now()}`;
  const res = await fetch(url, { cache: "no-store" });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    const err = new Error(body.error?.message || "REQUEST_FAILED");
    err.status = res.status;
    throw err;
  }
  return res.json();
}

// 初始化上传
export async function initUpload(token, { filename, fileSize, mimeType }) {
  const base = getBase();
  const res = await fetch(`${base}/api/file-transfer/${encodeURIComponent(token)}/upload/init`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ filename, fileSize, mimeType }),
  });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    const err = new Error(body.error?.message || "UPLOAD_INIT_FAILED");
    err.status = res.status;
    throw err;
  }
  return res.json();
}

// 完成上传
export async function completeUpload(token, { fileId, uploadType, parts, uploadId }) {
  const base = getBase();
  const res = await fetch(`${base}/api/file-transfer/${encodeURIComponent(token)}/upload/complete`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ fileId, uploadType, parts, uploadId }),
  });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    const err = new Error(body.error?.message || "COMPLETE_FAILED");
    err.status = res.status;
    throw err;
  }
  return res.json();
}

// 中止上传
export async function abortUpload(token, { fileId, uploadId }) {
  const base = getBase();
  const res = await fetch(`${base}/api/file-transfer/${encodeURIComponent(token)}/upload/abort`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ fileId, uploadId }),
  });
  return res.ok;
}

// 查询已上传 parts（断点续传用）
export async function listUploadParts(token, { fileId, uploadId }) {
  const base = getBase();
  const url = `${base}/api/file-transfer/${encodeURIComponent(token)}/upload/parts?fileId=${encodeURIComponent(fileId)}&uploadId=${encodeURIComponent(uploadId)}`;
  const res = await fetch(url);
  if (!res.ok) throw new Error("LIST_PARTS_FAILED");
  return res.json();
}

// 下载文件（预签名）
export async function getFileDownloadUrl(token, fileId) {
  const base = getBase();
  const url = `${base}/api/file-transfer/${encodeURIComponent(token)}/download/${encodeURIComponent(fileId)}?mode=presigned`;
  const res = await fetch(url);
  if (!res.ok) throw new Error("DOWNLOAD_FAILED");
  const body = await res.json();
  return body.downloadUrl;
}

// 流式下载 URL
export function getStreamDownloadUrl(token, fileId) {
  const base = getBase();
  return `${base}/api/file-transfer/${encodeURIComponent(token)}/download/${encodeURIComponent(fileId)}?mode=proxy`;
}

// 公开删除文件（任何人只要有链接 token 就能删除）
export async function deletePublicFile(token, fileId) {
  const base = getBase();
  const res = await fetch(`${base}/api/file-transfer/${encodeURIComponent(token)}/files/${encodeURIComponent(fileId)}`, {
    method: "DELETE",
  });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    const err = new Error(body.error?.message || "DELETE_FAILED");
    err.status = res.status;
    throw err;
  }
  return true;
}
